// extracted by mini-css-extract-plugin
module.exports = {"SpaPresentation":"SpaPresentation_SpaPresentation__3SZ06","SpaPresentation__image":"SpaPresentation_SpaPresentation__image__1UXpf"};